import { HospitalInfoEntity } from "@/domain/entity/hospital-info-entity";
import { HospitalInfoResponseDto } from "../dto/hospital-info-reponse-dto";
import { assertHospitalInfoResponseDto } from "@/utils/validation";

export class HospitalInfoMapper {
  static toEntity(dto: HospitalInfoResponseDto): HospitalInfoEntity {
    // AST 기반 타입 검증
    assertHospitalInfoResponseDto(dto);
    return {
      name: dto.hospitalName,
      code: dto.hospitalCode,
      doctorRegisterCount: dto.doctorRegisterCount,
      patientRegisterCount: dto.patientRegisterCount,
    };
  }

  static toEntityList(dto: HospitalInfoResponseDto[]): HospitalInfoEntity[] {
    return dto.map((dto) => HospitalInfoMapper.toEntity(dto));
  }
}
